var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('router-view',{staticStyle:{"height":"100%"}}),_c('my-snackbar'),_c('my-confirm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }